import React from 'react'
import createClass from 'create-react-class'
const socials = [
  {
    url: 'http://bit.ly/2rBrcYMTwtr',
    className: 'icon-twitter-box'
  },
  {
    url: 'http://bit.ly/2pV8pdLTlgrm',
    className: 'icon-telegram'
  },
  {
    url: 'http://bit.ly/2qATyUIFB',
    className: 'icon-facebook-box'
  },
  {
    url: 'http://bit.ly/2qAY2dUINST',
    className: 'icon-instagram'
  },
  {
    url: 'http://bit.ly/2pVeQ0rAPRT',
    className: 'icon-aparat'
  }
]
const FooterSocialLinks = createClass({
  render () {
    return (
      <div className='Social-Links'>
        {socials.map(item => (
          <span key={item.url}>
            <a href={item.url} target='_blank'>
              <i className={item.className} />
            </a>
          </span>
        ))}
      </div>
    )
  }
})

module.exports = FooterSocialLinks



// WEBPACK FOOTER //
// ./src/js/components/common/FooterSocialLinks.react.js